
/// <reference path="../membershipManager.module.ts" />
module Meevo.Plugins.MembershipManager {

    class ManualPayBillModalController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            'modalTitle',
            'modalSubTitle',
            'bills'
        ];

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public modalTitle: string,
            public modalSubTitle: string,
            public bills: any
        ) {
            
        }

        apply = () => {
            this.$mdDialog.hide(true);
        };

        cancel = () => {
            this.$mdDialog.hide(false);
        };
    }

    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.ManualPayBillModalController", ManualPayBillModalController);
}